import React from 'react'
import Moment from 'moment'
import momentLocalizer from 'react-widgets/lib/localizers/moment'
import DropdownList from 'react-widgets/lib/DropdownList'
import NumberPicker from 'react-widgets/lib/NumberPicker'
import numberLocalizer from 'react-widgets/lib/localizers/simple-number'
import CityPair from './CityPair'
import FlightDatePicker from './FlightDatePicker'
import PromoCode from './PromoCode'
import { fetchJSON, cleanAirports, getStateAsQuery } from './helpers'
import config from './config'
import getLang from './lang'
import './styles/react-widgets/less/react-widgets.less'
import './styles/app.less'

momentLocalizer(Moment)
numberLocalizer()

let airports = []

class BookingForm extends React.Component {
  constructor (props) {
    super(props)

    const validLang = config.langs.indexOf(this.props.lang) > -1
    const today = new Date()

    this.state = {
      loading: false,
      from: this.props.from || '',
      to: this.props.to || '',
      from2: '',
      to2: '',
      departureDate: {
        value: Moment(today).add(7, 'days').toDate(),
        min: today,
        max: new Date(2099, 11, 30)
      },
      returnDate: {
        value: Moment(today).add(14, 'days').toDate(),
        min: new Date(),
        max: new Date(2099, 11, 30)
      },
      type: this.props.type || 'rt',
      adults: parseInt(this.props.adults, 10) || 1,
      children: parseInt(this.props.children, 10) || 0,
      infants: parseInt(this.props.infants, 10) || 0,
      promo: this.props.promo || '',
      lang: validLang ? this.props.lang : 'en'
    }

    Moment.locale(this.state.lang)

    this.handleReturnDateChange = this.handleReturnDateChange.bind(this)
    this.handleDepartureDateChange = this.handleDepartureDateChange.bind(this)
  }

  componentDidMount () {
    this.setState({ loading: true })

    fetchJSON(config.cityPairsURL(this.state.lang)).then(cleanAirports).then(data => {
      airports = data

      this.setState({
        loading: false
      })
    })
  }

  shouldComponentUpdate (nextProps, nextState) {
    const slotsLeft = nextState.adults + nextState.children < 10
    const enoughAdults = nextState.adults >= nextState.infants
    const shouldUpdate = slotsLeft && enoughAdults

    if (!shouldUpdate) {
      this.setState(this.state)
    }

    return shouldUpdate
  }

  handleDestinationChange (destinationKey, airport) {
    this.setState({
      [destinationKey]: airport.airportRef
    })
  }

  handleDepartureDateChange (newDepartureDate) {
    let departureDate = this.state.departureDate
    let returnDate = this.state.returnDate

    departureDate.value = newDepartureDate
    returnDate.min = newDepartureDate

    this.setState({
      departureDate: departureDate,
      returnDate: returnDate
    })
  }

  handleReturnDateChange (date) {
    let departureDate = this.state.departureDate
    let returnDate = this.state.returnDate

    returnDate.value = date
    departureDate.max = date || new Date(2099, 11, 30)

    this.setState({
      departureDate: departureDate,
      returnDate: returnDate
    })
  }

  onTypeChange (value) {
    if (value.id === 'ow') {
      this.handleReturnDateChange(null)
    }

    this.setState({
      type: value.id
    })
  }

  onAdultsChange (count) {
    this.setState({
      adults: count
    })
  }
  onChildrenChange (count) {
    this.setState({
      children: count
    })
  }
  onInfantsChange (count) {
    this.setState({
      infants: count
    })
  }

  handlePromoCodeChange (e) {
    this.setState({
      promo: e.target.value
    })
  }

  handleSubmit (e) {
    const query = getStateAsQuery(this.state)
    const baseURL = config.submitURL(this.state.lang)

    console.log(query)

    const popup = window.open(`${baseURL}${query}`, query, 'modal=true')
    popup.focus()
    // has valid FROM and TO destinations and they differ
    // if multicity: has valid FROM2 and TO2 and they differ
    // has DATEFROM and DATETO and they are in future and consecutive
    // has at max 9 adults and children combined
    // has at max as many infants as adults
    // valid promo code?
  }

  render () {
    let returnDateComponent = null
    let multiCityPair = null
    const l = getLang(this.state.lang)

    if (this.state.type !== 'ow') {
      returnDateComponent = <FlightDatePicker
        {...this.state.returnDate}
        onChange={this.handleReturnDateChange}
      />
    }
    if (this.state.type === 'oj') {
      multiCityPair = <CityPair
        from={this.state.from2}
        to={this.state.to2}
        airports={airports}
        loading={this.state.loading}
        onDestinationChange={this.handleDestinationChange.bind(this)}
        type='2'
        l={l}
      />
    }

    return (
      <div id='bf-container'>
        <DropdownList
          data={l.journeyTypes}
          valueField='id'
          textField='name'
          defaultValue={this.state.type}
          onChange={this.onTypeChange.bind(this)}
        />

        <CityPair
          from={this.state.from}
          to={this.state.to}
          airports={airports}
          loading={this.state.loading}
          onDestinationChange={this.handleDestinationChange.bind(this)}
          type=''
          l={l}
        />

        {multiCityPair}

        <FlightDatePicker
          {...this.state.departureDate}
          onChange={this.handleDepartureDateChange}
        />

        {returnDateComponent}

        <div className='row'>
          <div className='col-xs-4'>
            <label>{l.adultsLabel}:</label>
            <NumberPicker
              min={0}
              value={this.state.adults}
              onChange={this.onAdultsChange.bind(this)}
            />
          </div>
          <div className='col-xs-4'>
            <label>{l.childrenLabel}:</label>
            <NumberPicker
              min={0}
              value={this.state.children}
              onChange={this.onChildrenChange.bind(this)}
            />
          </div>
          <div className='col-xs-4'>
            <label>{l.infantsLabel}:</label>
            <NumberPicker
              min={0}
              value={this.state.infants}
              onChange={this.onInfantsChange.bind(this)}
            />
          </div>
        </div>

        <PromoCode
          value={this.state.promo}
          onPromoCodeChange={this.handlePromoCodeChange.bind(this)}
          l={l}
        />

        <button type='submit' onClick={this.handleSubmit.bind(this)}>{l.submitText}</button>
      </div>
    )
  }
}

BookingForm.propTypes = {
  'lang': React.PropTypes.oneOf([...config.langs, '']),
  'type': React.PropTypes.oneOf(config.journeyTypes),
  'from': React.PropTypes.string,
  'to': React.PropTypes.string,
  'adults': React.PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
  'children': React.PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
  'infants': React.PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9]),
  'promo': React.PropTypes.string
}

export default BookingForm



/** WEBPACK FOOTER **
 ** ./src/BookingForm.js
 **/